import { suiteLoginUrl } from "../../lib/api-client";

interface LoginPageProps {
  /** Shown above the subtitle — the signed-out page uses it to say what happened. */
  title?: string;
  cta?: string;
}

export function LoginPage({ title, cta = "Sign in with Skarn Suite" }: LoginPageProps = {}) {
  // Suite SSO bounce — uses `?callback=` (see suiteLoginUrl). The missing-
  // VITE_SUITE_URL build-time warning lives in api-client.ts (loaded app-wide).
  const loginUrl = suiteLoginUrl();

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">
          <span className="login-logo-text">Skarn</span>
          <span className="login-logo-product">Capture</span>
        </div>
        {title && <h1 className="login-title">{title}</h1>}
        <p className="login-subtitle">
          High-volume document capture and data keying
        </p>
        <a href={loginUrl} className="login-button">
          {cta}
        </a>
      </div>

      <style>{`
        .login-page {
          display: flex;
          align-items: center;
          justify-content: center;
          min-height: 100vh;
          background: var(--color-bg-primary);
        }
        .login-card {
          text-align: center;
          padding: var(--space-12) var(--space-10);
          background: var(--color-bg-secondary);
          border: 1px solid var(--color-border);
          border-radius: var(--radius-md);
          max-width: 400px;
          width: 100%;
        }
        .login-logo {
          margin-bottom: var(--space-4);
        }
        .login-logo-text {
          font-size: 1.5rem;
          font-weight: 600;
          color: var(--color-text-secondary);
          margin-right: var(--space-2);
        }
        .login-logo-product {
          font-size: 1.5rem;
          font-weight: 700;
          color: var(--color-primary);
        }
        .login-title {
          margin: 0 0 var(--space-3);
          font-size: 1.1rem;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.05em;
          color: var(--color-text-primary);
        }
        .login-subtitle {
          color: var(--color-text-muted);
          margin-bottom: var(--space-8);
          font-size: 0.9rem;
        }
        .login-button {
          display: inline-block;
          padding: var(--space-3) var(--space-6);
          background: var(--color-primary);
          color: white;
          text-decoration: none;
          border-radius: var(--radius-sm);
          font-weight: 600;
          font-size: 0.95rem;
          transition: opacity 0.15s;
        }
        .login-button:hover {
          opacity: 0.9;
        }
        .loading-screen {
          display: flex;
          align-items: center;
          justify-content: center;
          min-height: 100vh;
        }
        .loading-spinner {
          width: 32px;
          height: 32px;
          border: 3px solid var(--color-border);
          border-top-color: var(--color-primary);
          border-radius: 50%;
          animation: spin 0.8s linear infinite;
        }
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}
